/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React, { useContext, useState } from "react";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import { DocumentContext } from "~context/DocumentContext";
import Footer from "~components/Footer";
import Layout from "~components/Layout";
import SEO from "~components/SEO";
import { splitStringToParagraphs } from "~utils/helpers";

import greenWave from "~assets/images/green-wave.png";
import greenWaveXS from "~assets/images/green-wave-xs.png";

const AboutPage = ({ data, location }) => {
  const { device } = useContext(DocumentContext);

  const [expandedPerson, setExpandedPerson] = useState(null);

  //

  const { frontmatter } = data.markdownRemark;

  //

  return (
    <>
      <SEO
        customTitle={frontmatter.title}
        customDescription={frontmatter.seoDescription}
        customKeywords={frontmatter.seoKeywords}
        path={location.pathname}
      />

      <Layout className="index-page w-full relative pt-32 md:pt-48 bg-cream text-dark-green">
        <section className="grid pb-24">
          <div className="grid-end-12 sm:grid-end-10 md:grid-end-8 sm:grid-start-2 md:grid-start-3">
            <figure className="w-full relative block">
              {frontmatter?.image?.childImageSharp?.fluid && (
                <Img
                  className="animation-fade-in-slow animation-delay-2 w-full relative block"
                  fluid={frontmatter.image.childImageSharp.fluid}
                  alt={frontmatter.imageAlt}
                />
              )}
            </figure>
          </div>

          <h2
            className={`animation-appear-slow animation-delay-3 grid-end-12 sm:grid-end-10 md:grid-end-8 sm:grid-start-2 md:grid-start-3 mt-10 sm:mt-12 ${
              device === `desktop` ? `b1` : `f4`
            } text-light-green text-center`}
          >
            {frontmatter.subheading}
          </h2>
          <h1
            className={`animation-appear-slow animation-delay-4 grid-end-12 sm:grid-end-8 sm:grid-start-3 mt-4 md:mt-2 mb-8 sm:mb-12 ${
              device && device === `desktop` ? `f2` : `f3`
            } sm:text-center`}
          >
            {frontmatter.heading}
          </h1>

          <p
            className={`animation-appear-slow animation-delay-5 grid-end-12 sm:grid-end-5 md:grid-end-4 sm:grid-start-2 md:grid-start-3 ${
              device === `desktop` ? `f5` : `f4`
            } relative mb-6 sm:pr-2 md:pr-5 text-orange`}
          >
            {frontmatter.intro}
          </p>

          <div className="animation-appear-slow animation-delay-5 grid-end-12 sm:grid-end-5 md:grid-end-4 sm:pl-5 text-dark-green">
            {splitStringToParagraphs(frontmatter.text, `mb-4 sm:mb-3 b1`)}
          </div>
        </section>

        <section className="w-full relative block pt-32 pb-24 bg-dark-green text-cream">
          <div className="w-2/5 sm:w-1/4 md:w-1/5 absolute top-0 left-0 -mt-12 sm:-mt-32 md:-mt-48 ml-8 sm:ml-24 z-10 invert-x">
            {(frontmatter?.illustration?.childImageSharp?.fluid && (
              <Img
                className="w-full h-full relative block"
                fluid={frontmatter.illustration.childImageSharp.fluid}
                alt={frontmatter.illustrationAlt || `Illustration`}
              />
            )) || (
              <>
                {frontmatter?.illustration?.publicURL && (
                  <img
                    className="w-full h-full relative block"
                    src={frontmatter.illustration.publicURL}
                    alt={frontmatter.illustrationAlt || `Illustration`}
                  />
                )}
              </>
            )}
          </div>

          <div className="w-full h-full absolute top-0 right-0 bottom-0 left-0">
            {(device && device === `mobile` && (
              <img
                className="w-full relative block -mt-4"
                src={greenWaveXS}
                alt="Green wave XS"
              />
            )) || (
              <img
                className="w-full h-full relative block -mt-12"
                src={greenWave}
                alt="Green wave"
              />
            )}
          </div>

          <div className="grid">
            <h2
              className={`grid-end-12 ${
                device && device === `desktop` ? `f5` : `f4`
              } text-light-green text-center`}
            >
              Our People
            </h2>

            {frontmatter?.people?.[0] &&
              frontmatter.people.map((person, personIndex) => {
                return (
                  <div
                    key={person.name}
                    className={`grid-end-12 sm:grid-end-5 md:grid-end-4 ${
                      personIndex % 2 === 0
                        ? `sm:grid-start-2 md:grid-start-3`
                        : ``
                    } mt-8 sm:mt-12 mb-4 sm:mb-12 px-6 sm:px-2 md:px-6`}
                  >
                    <figure className="w-full relative block">
                      <Img
                        className="w-full relative block"
                        fluid={person.image.childImageSharp.fluid}
                        alt={person.name}
                      />
                    </figure>

                    <div className="sm:h-20 md:h-32 relative flex items-center justify-center mt-6 mb-6 sm:mb-2 md:mb-6">
                      <h3
                        className={`${
                          device && device === `desktop` ? `f2` : `f3`
                        } text-center`}
                      >
                        {person.name}
                      </h3>
                    </div>

                    {(device && device === `desktop` && (
                      <>
                        <p className="mb-4 f5 text-light-green">
                          {person.profile}
                        </p>

                        {splitStringToParagraphs(
                          person.bio,
                          `mb-4 b1 text-light-cream`
                        )}
                      </>
                    )) || (
                      <>
                        <p className="mb-8 f4 text-light-green">
                          {person.profile}
                        </p>

                        <button
                          type="button"
                          className="w-full relative block b1 text-center text-orange"
                          onClick={() =>
                            setExpandedPerson(
                              expandedPerson === personIndex
                                ? null
                                : personIndex
                            )
                          }
                        >
                          Read{` `}
                          {expandedPerson === personIndex ? `less -` : `more +`}
                        </button>

                        {expandedPerson === personIndex &&
                          splitStringToParagraphs(
                            person.bio,
                            `animation-appear-down-slow mt-6 mb-4 b1 text-light-cream`
                          )}
                      </>
                    )}
                  </div>
                );
              })}
          </div>
        </section>

        <Footer />
      </Layout>
    </>
  );
};

export default AboutPage;

export const query = graphql`
  query AboutPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        image {
          childImageSharp {
            fluid(maxWidth: 1440, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
          publicURL
        }
        imageAlt
        illustration {
          childImageSharp {
            fluid(maxWidth: 1440, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
          publicURL
        }
        illustrationAlt
        subheading
        heading
        intro
        text
        people {
          name
          profile
          bio
          image {
            childImageSharp {
              fluid(maxWidth: 512, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
            publicURL
          }
        }
        seoDescription
        seoKeywords
      }
    }
  }
`;
